<div class="p-6 px-0 w-full h-full flex flex-col">
  <div class="pt-0 pb-3 flex flex-col md:flex-row md:items-center md:justify-start gap-4">
    <div class="shrink-0">
      <ng-content select="[table-title]"></ng-content>
    </div>
    <div class="flex items-center gap-4">
      <nz-pagination [nzPageIndex]="pageIndex" [nzTotal]="totalData" [nzPageSize]="pageSize"
        (nzPageIndexChange)="handlePageIndexChange($event)" [nzItemRender]="renderItemTemplate"></nz-pagination>
      <prism-select-page-size (pageSize)="handlePageSizeChange($event)">
      </prism-select-page-size>
    </div>
    <ng-template #renderItemTemplate let-type let-page="page">
      @switch (type) { @case ('page') {
      <a href="javascript:void(0)" tabindex="0" role="button" aria-label="Go to page {{ page }}">
        {{ page }}
      </a>
      } @case ('prev') {
      <a href="javascript:void(0)" tabindex="0" role="button" aria-label="Go to previous page">
        Previous
      </a>
      } @case ('next') {
      <a href="javascript:void(0)" tabindex="0" role="button" aria-label="Go to next page">
        Next
      </a>
      }
      }
    </ng-template>
  </div>
  <div class="flex-grow relative overflow-x-auto">
    <ng-container *ngIf="tableData && tableData.length > 0">
      <table class="mt-4 w-full table-auto text-left" role="table" aria-label="Data Table">
        <thead role="rowgroup">
          <tr role="row">
            @for (col of columns; track col) {
            <th role="columnheader" class="px-2 sm:px-4 whitespace-nowrap">
              <button type="button"
                class="text-sm font-semibold text-dark-purple flex items-center justify-start gap-2 w-full"
                (click)="handleSortByColumn(col)" [attr.aria-label]="'Sort by ' + (colHeaders[col] ?? col)">
                {{ colHeaders[col] ?? col }}
                  <i *ngIf="sortColumn === col" class="uil" [ngClass]="{
                      'uil-angle-up': sortDirection === 'asc',
                      'uil-angle-down': sortDirection === 'desc'
                    }">
                    </i>
              </button>

            </th>
            }
            @if (isDelete || isEdit) {
            <th role="columnheader" class="px-2 sm:px-4 whitespace-nowrap">
              <p class="text-sm font-semibold bg-none text-dark-purple flex items-center justify-between gap-2"></p>
            </th>
            }
          </tr>
        </thead>
        <tbody role="rowgroup">
          @for (data of tableData; track $index) {
          <tr class="bg-light-purple border-y-8 border-white sm:m-5" role="row">
            @for (col of columns; track col) {
            <td class="py-2 px-2 sm:px-4" [ngClass]="{ 'rounded-l-2xl': $index === 0, 'whitespace-nowrap': col === 'status' || col === 'completedOn' || col === 'fullName' }" role="cell" tabindex="0"
              [attr.aria-label]="colHeaders[col] + ': ' + data[col]" title="{{ data[col] }}">
              <div [ngClass]="{'max-w-xs md:max-w-sm lg:max-w-md break-words': col === 'districtName'}">
                {{ data[col] }}
              </div>
            </td>
            }
            <td class="rounded-r-2xl" role="cell">
              @for (item of actions; track $index) {
              @if (item.isActive) {
              <button class="pl-2 text-2xl" [attr.aria-label]="item.label" (click)="item.handler(data, item.type)">
                <i [class]="item.icon"></i>
              </button>
              }
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </ng-container>
    <!-- Show empty table -->
    <ng-container *ngIf="tableData && tableData.length < 1">
      <nz-table class="mt-4 w-full table-auto text-left" [nzData]="tableData">
        <tbody>
        </tbody>
      </nz-table>
    </ng-container>
  </div>
  <div class="flex justify-start pt-3 lg:pt-6">
    <div class="relative inline-flex">
      <div class="flex flex-wrap items-center justify-start">
        <nz-pagination [nzPageIndex]="pageIndex" [nzTotal]="totalData" [nzPageSize]="pageSize"
          (nzPageIndexChange)="handlePageIndexChange($event)" [nzItemRender]="renderItemTemplate"></nz-pagination>
      </div>
    </div>
  </div>
</div>